import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/Login',
    component: resolve => require(['@/page/Login.vue'], resolve),
  }, {
    path: '/',
    component: resolve => require(['@/page/index.vue'], resolve),
    redirect: '/message/message',
    children: [{
        path: '/setup/system_manage/system_list',
        component: resolve => require(['@/page/setup/system_manage/system_list.vue'], resolve),
      },
      {
        path: '/setup/system_manage/add_system',
        component: resolve => require(['@/page/setup/system_manage/add_system.vue'], resolve),
      },
      {
        path: '/setup/system_manage/grouping_list',
        component: resolve => require(['@/page/setup/system_manage/grouping_list.vue'], resolve),
      },
      {
        path: '/setup/system_manage/add_grouping',
        component: resolve => require(['@/page/setup/system_manage/add_grouping.vue'], resolve),
      },
      {
        path: '/setup/mini_app/share',
        component: resolve => require(['@/page/setup/mini_app/share.vue'], resolve),
      },
      {
        path: '/setup/system_manage/grouping_list',
        component: resolve => require(['@/page/setup/system_manage/grouping_list.vue'], resolve),
      },
      {
        path: '/test',
        component: resolve => require(['@/page/test.vue'], resolve),
      },
      {
        path: '/case/add_case',
        component: resolve => require(['@/page/case/add_case.vue'], resolve),
      },
      {
        path: '/case/case_list',
        component: resolve => require(['@/page/case/case_list.vue'], resolve),
      },
      {
        path: '/member/add_member',
        component: resolve => require(['@/page/member/add_member.vue'], resolve),
      },
      {
        path: '/member/member_list',
        component: resolve => require(['@/page/member/member_list.vue'], resolve),
      },
      {
        path: '/member/tags/case_class',
        component: resolve => require(['@/page/member/tags/case_class.vue'], resolve),
      },
      {
        path: '/member/tags/add_case_class',
        component: resolve => require(['@/page/member/tags/add_case_class.vue'], resolve),
      },
      {
        path: '/member/tags/member',
        component: resolve => require(['@/page/member/tags/member.vue'], resolve),
      },
      {
        path: '/member/tags/add_member',
        component: resolve => require(['@/page/member/tags/add_member.vue'], resolve),
      },
      {
        path: '/member/tags/department',
        component: resolve => require(['@/page/member/tags/department.vue'], resolve),
      },
      {
        path: '/member/tags/add_department',
        component: resolve => require(['@/page/member/tags/add_department.vue'], resolve),
      },
      {
        path: '/address/address',
        component: resolve => require(['@/page/address/address.vue'], resolve),
      },
      {
        path: '/address/add_address',
        component: resolve => require(['@/page/address/add_address.vue'], resolve),
      },
      {
        path: '/message/message',
        component: resolve => require(['@/page/message/message.vue'], resolve),
      },
      {
        path: '/message/add_message',
        component: resolve => require(['@/page/message/add_message.vue'], resolve),
      },
      {
        path: '/article/article_list',
        component: resolve => require(['@/page/article/article_list.vue'], resolve),
      },
      {
        path: '/article/add_article',
        component: resolve => require(['@/page/article/add_article.vue'], resolve),
      },
      {
        path: '/member/tags/article_cate',
        component: resolve => require(['@/page/member/tags/article_cate.vue'], resolve),
      },
      {
        path: '/member/tags/add_article_cate',
        component: resolve => require(['@/page/member/tags/add_article_cate.vue'], resolve),
      },
    ]
  }],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js